import { Component, ViewEncapsulation, output, input } from '@angular/core';

import { NavigationItem, NavigationType, ProfileMenu, ProfileMenuItem } from '../header.model';
import { ApMenuItemComponent } from '../menu-item/menu-item.component';

import { ApHorizontalMenuPopoverComponent } from './horizontal-menu-popover/horizontal-menu-popover.component';
import { ApHorizontalMenuUserComponent } from './horizontal-menu-user/horizontal-menu-user.component';

/**
 * @ngdoc component
 * @name ApHorizontalMenuComponent
 *
 * @param {NavigationItem[]} [navigationItems] The navigation items
 * Can be either empty or small (to match the application canvas-small layout)
 */
@Component({
    selector: 'ap-horizontal-menu',
    templateUrl: './horizontal-menu.component.html',
    styleUrls: ['./horizontal-menu.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApMenuItemComponent, ApHorizontalMenuPopoverComponent, ApHorizontalMenuUserComponent]
})
export class ApHorizontalMenuComponent {
    /**
     * Required - The navigation items
     */
    public readonly navigationItems = input.required<NavigationItem[]>();

    /**
     * Is user logged in?
     * If not set no login will be shown.
     * If false login-button will be shown.
     * If true logged in state will be shown
     */
    public readonly isLoggedIn = input<boolean>();

    /**
     * Profile menu with user data
     */
    public readonly profileMenu = input<ProfileMenu>();

    /**
     * emits the NavigationItem that is clicked
     */
    public readonly navigationClicked = output<NavigationItem>();

    /**
     * Emits event to login
     * Passes `isLoggedIn` boolean
     */
    public readonly loginLogout = output<boolean>();

    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     * Emits clicked profile menu item
     */
    public readonly profileItemClicked = output<ProfileMenuItem>();

    public navigationType = NavigationType;
}
